import LegalPage from "../../components/LegalPage/LegalPage";
import { privacyPolicy } from "../../constants/privacyPolicy";

const PrivacyPolicyPage = () => <LegalPage title="Privacy Policy" content={privacyPolicy} />;

export default PrivacyPolicyPage;
